import React from "react";
import { Clock, MapPin } from "lucide-react";
import Reveal, { Eyebrow } from "../common/Reveal";
import { events } from "../../mock";

export default function Events() {
  return (
    <section id="events" className="bg-lybl-paper py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-xl">
            <Reveal><Eyebrow>{events.eyebrow}</Eyebrow></Reveal>
            <Reveal delay={80}><h2 className="mt-4 font-serif text-4xl lg:text-5xl text-lybl-ink">{events.title}</h2></Reveal>
            <Reveal delay={140}><p className="mt-4 text-lybl-muted text-lg">{events.subtitle}</p></Reveal>
          </div>
          <Reveal delay={160}>
            <a href="#" className="inline-flex items-center gap-2 rounded-full border border-lybl-green/30 px-5 py-2.5 text-[14px] font-medium text-lybl-green hover:bg-lybl-green hover:text-white transition-colors">View All Events</a>
          </Reveal>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {events.items.map((e, i) => (
            <Reveal key={e.title} delay={i * 90}>
              <a href="#" className="group block overflow-hidden rounded-3xl bg-white ring-1 ring-black/5 hover:shadow-xl transition-shadow">
                <div className="relative h-52 overflow-hidden">
                  <img src={e.image} alt={e.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute top-4 left-4 rounded-xl bg-white/95 px-3 py-2 text-center shadow">
                    <p className="font-serif text-xl leading-none text-lybl-ink">{e.day}</p>
                    <p className="text-[11px] uppercase tracking-wide text-lybl-muted">{e.mon}</p>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 text-[12px] text-lybl-muted">
                    <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {e.time}</span>
                    <span>· {e.dur}</span>
                  </div>
                  <h3 className="mt-2 font-serif text-lg text-lybl-ink leading-snug">{e.title}</h3>
                  <div className="mt-3 flex items-center gap-2 text-[12px]">
                    <span className="inline-flex items-center gap-1 rounded-full bg-lybl-cream px-2.5 py-1 text-lybl-ink/70"><MapPin className="h-3 w-3" /> {e.type}</span>
                    <span className="rounded-full bg-lybl-green/10 px-2.5 py-1 text-lybl-green font-medium">{e.status}</span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
